import { render, staticRenderFns } from "./project-item-add-button.vue?vue&type=template&id=fe6e692c&"
import script from "./project-item-add-button.vue?vue&type=script&lang=js&"
export * from "./project-item-add-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports